import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Button, Space, Tag, Popconfirm, message } from 'antd';

const { Title, Paragraph } = Typography;

const CampaignsFlagged = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      // Placeholder data; replace with GET /api/campaigns?flagged=true or similar endpoint
      const mock = [
        { id: 901, name: 'Geo Expansion', client: 'Contoso Retail', flagged_reason: 'Abnormal spend spike', status: 'active', flagged_at: '2025-08-13 09:41' },
        { id: 902, name: 'Retargeting Blitz', client: 'Tailwind Co', flagged_reason: 'Low CTR threshold', status: 'paused', flagged_at: '2025-08-12 18:05' },
      ];
      setData(mock);
    } catch (e) {
      message.error(e.message || 'Failed to load flagged campaigns');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const markReviewed = async (record) => {
    try {
      // Replace with PUT /api/campaigns/:id/flags/resolve
      await new Promise(r => setTimeout(r, 300));
      message.success(`Marked reviewed #${record.id}`);
      setData(prev => prev.filter(c => c.id !== record.id));
    } catch (e) {
      message.error(e.message || 'Failed to mark reviewed');
    }
  };

  const dismissFlag = async (record) => {
    try {
      // Replace with PUT /api/campaigns/:id/flags/dismiss
      await new Promise(r => setTimeout(r, 300));
      message.success(`Dismissed flag #${record.id}`);
      setData(prev => prev.filter(c => c.id !== record.id));
    } catch (e) {
      message.error(e.message || 'Failed to dismiss flag');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 90 },
    { title: 'Campaign', dataIndex: 'name', key: 'name' },
    { title: 'Client', dataIndex: 'client', key: 'client' },
    { title: 'Reason', dataIndex: 'flagged_reason', key: 'flagged_reason' },
    { title: 'Flagged At', dataIndex: 'flagged_at', key: 'flagged_at', width: 180 },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => (
        <Tag color={s === 'active' ? 'green' : s === 'paused' ? 'orange' : 'default'}>{s}</Tag>
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Popconfirm title="Mark this campaign as reviewed?" onConfirm={() => markReviewed(record)} okText="Mark Reviewed" okButtonProps={{ type: 'primary' }}>
            <Button size="small" type="primary">Mark Reviewed</Button>
          </Popconfirm>
          <Popconfirm title="Dismiss this flag?" onConfirm={() => dismissFlag(record)} okText="Dismiss" okButtonProps={{ danger: true }}>
            <Button size="small" danger>Dismiss</Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Campaigns' },
        { title: 'Flagged for Review' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Campaigns Flagged for Review</Title>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>
          Review flagged campaigns. Replace mock logic with your backend endpoints.
        </Paragraph>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </div>
  );
};

export default CampaignsFlagged;
